import React, { useEffect, useContext, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { UserContext } from '../App';
import { exchangeCodeForTokens, decodeIdToken } from '../utils/oidc';
import api from '../utils/api';

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setCurrentUser } = useContext(UserContext);
  const [error, setError] = useState('');

  useEffect(() => {
    (async () => {
      try {
        const domain = (typeof window !== 'undefined' && window.__COGNITO_DOMAIN__) || process.env.REACT_APP_COGNITO_DOMAIN || '';
        const clientId = process.env.REACT_APP_COGNITO_CLIENT_ID || '';
        const redirectUri = window.location.origin + '/auth/callback';
        const params = new URLSearchParams(window.location.search);
        const code = params.get('code');
        if (!domain || !clientId || !code) {
          setError('Missing OAuth parameters');
          return;
        }
        const codeVerifier = sessionStorage.getItem('pkce_verifier') || '';
        const tokens = await exchangeCodeForTokens({ domain, clientId, code, redirectUri, codeVerifier });
        const idPayload = decodeIdToken(tokens.id_token || '');
        if (!idPayload) {
          setError('Invalid id_token');
          return;
        }
        const bootstrapUser = {
          id: String(idPayload.sub || ''),
          email: String(idPayload.email || ''),
          name: String(idPayload.name || `${idPayload.given_name || ''} ${idPayload.family_name || ''}`.trim()),
          role: 'owner',
          type: 'owner',
          idToken: tokens.id_token,
          accessToken: tokens.access_token || ''
        };
        setCurrentUser(bootstrapUser);
        try { localStorage.setItem('currentUser', JSON.stringify(bootstrapUser)); } catch {}

        // Enrich from backend, which now derives role/activeContext from Cognito groups
        try {
          const me = await api.get('/auth/me');
          const enriched = {
            ...bootstrapUser,
            id: me.data.id || bootstrapUser.id,
            email: me.data.email || bootstrapUser.email,
            name: me.data.name || bootstrapUser.name,
            role: me.data.role || bootstrapUser.role,
            type: me.data.activeContext || bootstrapUser.type,
          };
          setCurrentUser(enriched);
          try { localStorage.setItem('currentUser', JSON.stringify(enriched)); } catch {}
        } catch {}
        navigate('/dashboard');
      } catch (e) {
        setError('Authentication failed');
      }
    })();
  }, [navigate, setCurrentUser]);

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      {error ? <div>{error}</div> : <div>Signing you in…</div>}
    </div>
  );
}


